// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"Container_buttonsContainer__9H1LX","visuallyHidden":"Container_visuallyHidden__QxBVC","a11yTitle":"Container_a11yTitle__1xjFd"};